import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FiArrowUpRight, FiMenu, FiX } = FiIcons;

const links = [
  { label: 'Work', href: '#work' },
  { label: 'Studio', href: '#studio' },
  { label: 'Services', href: '#services' },
  { label: 'Process', href: '#process' },
  { label: 'Journal', href: '#journal' }
];

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`}>
      <a className="wordmark" href="#top" aria-label="Forma Studio home" onClick={closeMenu}>
        <span className="wordmark-icon">F.</span>
        <span className="wordmark-name">FORMA<span>INTERIORS</span></span>
      </a>
      <button
        className="menu-toggle"
        type="button"
        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <SafeIcon icon={menuOpen ? FiX : FiMenu} />
      </button>
      <nav className={`header-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Main navigation">
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMenu}>
            {link.label}
          </a>
        ))}
        <button
          className="header-contact"
          type="button"
          onClick={() => {
            closeMenu();
            openWhatsApp("Hello Forma Interiors, I'd like to start a project.");
          }}
        >
          Start a project
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </nav>
    </header>
  );
}

export default SiteHeader;
